import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=b7a3f198"
import script from "./Groups.vue?vue&type=script&lang=ts"
export * from "./Groups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7a3f198')) {
      api.createRecord('b7a3f198', component.options)
    } else {
      api.reload('b7a3f198', component.options)
    }
    module.hot.accept("./Groups.vue?vue&type=template&id=b7a3f198", function () {
      api.rerender('b7a3f198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/Groups.vue"
export default component.exports